import React, { useState, useEffect } from 'react';
import { HStack } from '@chakra-ui/react';
import { ComboBox, Button } from '@spotoninc/nexus-react';
import { RegistrationHeader } from './RegistrationHeader';

export const AccountingSetup = ({ onNext, onCancel, companyData }) => {
  const [selectedSystem, setSelectedSystem] = useState(1);

  // Set the selected accounting system based on companyData
  useEffect(() => {
    if (companyData && companyData.accounting_software) {
      // Map the accounting_software string to the corresponding value
      if (companyData.accounting_software === 'quickbooks-online') {
        setSelectedSystem(1);
      } else if (companyData.accounting_software === 'xero') {
        setSelectedSystem(2);
      } else if (companyData.accounting_software === 'restaurant365') {
        setSelectedSystem(3);
      }
    }
  }, [companyData]);
  // Steps are defined in the parent component

  const accountingSystems = [
    {
      label: 'QuickBooks Online',
      value: 1,
    },
    {
      label: 'Xero',
      value: 2,
    },
    {
      label: 'Restaurant365',
      value: 3,
    },
  ];

  const handleContinue = () => {
    if (onNext) {
      onNext(selectedSystem);
    }
  };

  return (
    <>
      <RegistrationHeader
        title="Accounting System"
        description="Please select the accounting system you use to continue."
      />
      <ComboBox
        style={{
          maxWidth: '350px',
        }}
        value={selectedSystem}
        options={accountingSystems}
        onChange={(_, value) => {
          if (value !== undefined) {
            setSelectedSystem(value);
          }
        }}
      />

      <HStack spacing={3} justify="flex-start">
        <Button
          variant="tonal"
          size="medium"
          onClick={onCancel}
          style={{ paddingLeft: '24px', paddingRight: '24px' }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="medium"
          onClick={handleContinue}
          style={{
            paddingLeft: '45px',
            paddingRight: '45px',
          }}
        >
          Continue
        </Button>
      </HStack>
    </>
  );
};
